import {useModal} from "../../../hooks";
import FileUploadNoText from "../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import React, {useEffect, useMemo, useState} from "react";
import {useUploadBarcodeExcel} from "./hooks/useUploadIncomingExcel";
import SearchInventoryInner from "../../../components/common/modal/inner/SearchInventoryInner";
import {BarcodeObjectType} from "./interface";
import EmptyTableRow from "../../common/EmptyTableRow";
import {useForm, useWatch} from "react-hook-form";
import {barcodeObjectInit} from "./state";
import BarcodePrintFrame from "./features/BarcodePrintFrame";
import {useSearchParams} from "react-router-dom";
import {useReadInvDetail} from "../inv/detail/hooks/useReadInvDetail";
import InputNumberC from "../../../components/common/number/InputNumberC";

export const Barcode = () => {
    const {handleModal} = useModal();
    const defaultInventoryId = useSearchParams()[0].get("i")

    const {data: defaultInventoryIdDetail} = useReadInvDetail({id: Number(defaultInventoryId as string)})
    const {mutateAsync: mutateAsyncUploadBarcodeExcel} = useUploadBarcodeExcel()

    const [itemObject, setItemObject] = useState<BarcodeObjectType>(barcodeObjectInit)

    const {register, handleSubmit, reset, control, getValues, setValue} = useForm({
        defaultValues: itemObject,
    });

    const watchItemObject = {
        ...itemObject,
        ...useWatch<BarcodeObjectType>({control}),
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadBarcodeExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result

                    if (
                        getValues("itemList").some(el => list.map((el2: any) => el2.barcode).includes(el.barcode))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        const newList = list.map((el: any) => ({
                            ...el,
                            changeLog: "",
                            fileKey: el.erpProductImageVO?.fileKey ?? "",
                            fileUrl: el.erpProductImageVO?.fileUrl ?? "",
                            fileOrgname: el.erpProductImageVO?.fileOrgname ?? "",
                            changeAmount: el.quantity ?? 0
                        }))

                        setValue("itemList",
                            [...getValues("itemList"), ...newList]
                        )

                        setItemObject({...itemObject, itemList: [...getValues("itemList"), ...newList]})
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnSearchInventory = () => {
        handleModal({
            isOpen: true,
            contents: <SearchInventoryInner
                confirmCallback={(item) => {
                    console.log(item)

                    setValue("itemList",
                        [...getValues("itemList"), {
                            ...item,
                            changeLog: "",
                            fileKey: item.erpProductImageVO?.fileKey ?? "",
                            fileUrl: item.erpProductImageVO?.fileUrl ?? "",
                            fileOrgname: item.erpProductImageVO?.fileOrgname ?? "",
                            changeAmount: 1
                        }]
                    )
                    setItemObject({
                        ...itemObject, itemList: [...getValues("itemList"), {
                            ...item,
                            changeLog: "",
                            fileKey: item.erpProductImageVO?.fileKey ?? "",
                            fileUrl: item.erpProductImageVO?.fileUrl ?? "",
                            fileOrgname: item.erpProductImageVO?.fileOrgname ?? "",
                            changeAmount: 1
                        }]
                    })
                }}
                modalDepth={1}
            />,
            type: "",
            title: "재고 조회",
            modalSize: "xl",
        });
    }

    const btnDeleteItem = (idx: number) => {
        const list = getValues("itemList").filter((el, idx2) => idx !== idx2)

        setValue("itemList", list)
        setItemObject({...itemObject, itemList: list})
    }

    // TODO: 바코드 많아질 경우 렌더링 문제 있을 수 있음
    const barcodePrintFrame = useMemo(() => {
        return <BarcodePrintFrame itemList={watchItemObject.itemList.map(el => ({
            barcode: el.barcode ?? "",
            changeAmount: el.changeAmount ?? 0
        }))}/>
    }, [watchItemObject])

    useEffect(() => {
        if (defaultInventoryIdDetail) {
            setItemObject({
                itemList: [{
                    ...defaultInventoryIdDetail,
                    changeLog: "",
                    fileKey: defaultInventoryIdDetail.erpProductImageVO?.fileKey ?? "",
                    fileUrl: defaultInventoryIdDetail.erpProductImageVO?.fileUrl ?? "",
                    fileOrgname: defaultInventoryIdDetail.erpProductImageVO?.fileOrgname ?? "",
                    changeAmount: 1
                }]
            })
            setValue("itemList", [{
                ...defaultInventoryIdDetail,
                changeLog: "",
                fileKey: defaultInventoryIdDetail.erpProductImageVO?.fileKey ?? "",
                fileUrl: defaultInventoryIdDetail.erpProductImageVO?.fileUrl ?? "",
                fileOrgname: defaultInventoryIdDetail.erpProductImageVO?.fileOrgname ?? "",
                changeAmount: 1
            }])
        }
    }, [defaultInventoryIdDetail]);

    return (
        <div className="content_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">바코드 인쇄</h3>
                <div className="filter_toolbar">
                    {/* NOTE: 양식 다운로드 기능 없음 */}
                    {/*<button className="btn btn-info color2"><img*/}
                    {/*    src={process.env.PUBLIC_URL + "/assets/images/icon_download.png"} alt=""/>*/}
                    {/*    엑셀 양식 다운로드*/}
                    {/*</button>*/}
                    {/*<button className="btn btn-primary w-80px">인쇄</button>*/}
                </div>
            </div>

            <div className="barcode_sections">
                <div className="left">
                    <div className="d-flex align-items-center justify-content-between">
                        <h5 className="subheading">제품 정보</h5>
                        <div className="filter_toolbar">
                            <FileUploadNoText
                                addFileCallback={(file: File[]) => btnImportExcel(file)}
                                customRenderer={(onClick: any, disabled: any) =>
                                    <button className="btn btn-outline-dark w-150px px-0"
                                            onClick={onClick}
                                            disabled={disabled}><img
                                        src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                                    </button>

                                }
                                accept={".xlsx, .xls"}
                            />
                            <button className="btn btn-info w-100px ms-40px" onClick={btnSearchInventory}><img
                                src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>재고 검색
                            </button>
                        </div>
                    </div>
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <th style={{width: "7.14%"}}></th>
                            <th style={{width: "19.38%"}}>이미지</th>
                            <th style={{width: "58.1%"}}>제품 상세</th>
                            <th>인쇄 수량</th>
                        </tr>
                        </thead>
                        <tbody>
                        {watchItemObject.itemList.length !== 0
                            ? watchItemObject.itemList.map((el, idx) =>
                                <tr>
                                    <td className="text-center">
                                        <button className="btn btn-link p-0" onClick={() => btnDeleteItem(idx)}>
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                                                 alt=""/>
                                        </button>
                                    </td>
                                    <td className="p-4px"><img
                                        src={process.env.REACT_APP_SERVER_URL + `/api/file/images_download?fileKey=${el.fileKey}&fileUrl=${el.fileUrl}&fileOrgname=${el.fileOrgname}`}
                                        alt=""
                                        width={172}/></td>
                                    <td>
                                        <div className="line1">{el.newTxtNmItem}</div>
                                        <div className="line2">{el.newTxtStndItem}</div>
                                        {(() => {
                                            const list = [
                                                el.newTxtStndItem,
                                                el.inventoryUnit,]

                                            const result = list.filter(value => value !== undefined && value !== null && value !== '').join(' / ');

                                            return <div className="line3" title={result}>{result}</div>
                                        })()}
                                    </td>
                                    <td className="text-center">
                                        <InputNumberC value={el.changeAmount ?? 0}
                                                      onChange={e => setValue(`itemList.${idx}.changeAmount`, Number(e))}
                                                      onBlur={() => setItemObject((watchItemObject as BarcodeObjectType))}
                                        />
                                        {/*<input type="text" className="form-control text-end"
                                               value={el.changeAmount}
                                               onChange={e => setValue(`itemList.${idx}.changeAmount`, Number(e.target.value))}
                                               onBlur={() => setItemObject((watchItemObject as BarcodeObjectType))}
                                        />*/}
                                    </td>
                                </tr>
                            )
                            : <EmptyTableRow colSpan={4}/>}
                        <tr className="blue">
                            <td></td>
                            <td className="text-center"><span className="f-15">총 품목</span></td>
                            <td><span className="f-15">{watchItemObject.itemList.length}개 품목</span></td>
                            <td className="text-end">
                                <span className="f-15">
                                    총 {isNaN(watchItemObject.itemList.reduce((acc, cur) => acc + Number((cur.changeAmount as number)), 0))
                                    ? <>-</>
                                    : <>
                                        {watchItemObject.itemList.reduce((acc, cur) => acc + Number((cur.changeAmount as number)), 0)}
                                    </>}장
                                </span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div className="right">
                    {barcodePrintFrame}
                </div>
            </div>
        </div>
    );
}